import SurfaceActionsOptionState from '../store/schema/SurfaceActionsOptionState';
import getStore from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
import { getHoverSurfaceAction } from 'owa-surface-actions-option';

export interface DiscardSurfaceActionsOptionState {
    optionState: SurfaceActionsOptionState;
}

export default select<DiscardSurfaceActionsOptionState>({
    optionState: () => getStore(),
})(
    action('discardSurfaceActionsOption')(function discardSurfaceActionsOption(
        state?: DiscardSurfaceActionsOptionState
    ) {
        let { optionState } = state;
        optionState.readSurfaceActions = null;
        optionState.readSurfaceAddins = null;
        optionState.composeSurfaceActions = null;
        optionState.composeSurfaceAddins = null;

        // Instead of nulling out user's selection, simply retrieve last known value
        // from userConfig.
        optionState.hoverSurfaceActions = getHoverSurfaceAction();
    })
);
